<template>
  <form @submit.prevent="adicionarDadosCadastrais" autocomplete="off" class="mb-2">
    <div class="row">
      <div class="col-12">
        <fccTable
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          @row-selected="selecionaTipoDeDado"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-2 ml-auto text-right">
        <fccButton tipo="submit" :disabled="dadosSelecionados.length === 0">
          {{ labelsSystem.adicionar }}</fccButton
        >
      </div>
    </div>
  </form>
</template>
  
  <script>
export default {
  props: ['items'],
  emits: ['adicionar', 'input'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'descricao', label: 'Tipos de Dados Cadastrais', active: true }
      ],
      dadosSelecionados: []
    }
  },
  methods: {
    adicionarDadosCadastrais() {
      this.$emit('adicionar', this.dadosSelecionados)
    },
    selecionaTipoDeDado(dados) {
      this.dadosSelecionados = dados.map((element) => element.idtpdadoscadastrais)
    }
  }
}
</script>
  